import * as React from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import asyncComponent from "../../helpers/AsyncFunc"

class AppRouter extends React.Component<any, any> {
  public render() {
    return (
      <Switch>
        {/* redirect section */}
        <Redirect
          from={`/en/blog/พระธาตุประจำวันเกิด`}
          to={`/th/blog/พระธาตุประจำวันเกิด`}
        />
        <Redirect
          from={`/en/blog/5ที่เที่ยวใกล้กรุงเทพ`}
          to={`/th/blog/5ที่เที่ยวใกล้กรุงเทพ`}
        />
        <Redirect
          from={`/en/blog/ขับรถเที่ยวใกล้กรุงเทพฯ-7-ทริป-ชิลๆ-ไปเช้ากลับเย็น`}
          to={`/th/blog/ขับรถเที่ยวใกล้กรุงเทพฯ-7-ทริป-ชิลๆ-ไปเช้ากลับเย็น`}
        />
        <Redirect
          from={`/en/blog/จุดเด่นเมื่อเช่ารถบัสกับ-HISOBUS`}
          to={`/th/blog/จุดเด่นเมื่อเช่ารถบัสกับ-HISOBUS`}
        />
        <Redirect
          from={`/en/blog/10-เที่ยวใกล้กรุงเทพฯ-ตามรอยพ่อหลวง-สัมผัสความรู้เคล้าความสุข`}
          to={`/th/blog/10-เที่ยวใกล้กรุงเทพฯ-ตามรอยพ่อหลวง-สัมผัสความรู้เคล้าความสุข`}
        />
        <Redirect
          from={`/en/blog/18-ที่เที่ยวกาญจนบุรี-ไปกี่ทีก็ไม่เบื่อ`}
          to={`/th/blog/18-ที่เที่ยวกาญจนบุรี-ไปกี่ทีก็ไม่เบื่อ`}
        />
        <Redirect
          from={`/en/blog/1-กว่าจะเป็นรถบัส`}
          to={`/th/blog/1-กว่าจะเป็นรถบัส`}
        />
        <Redirect
          from={`/en/blog/10อันดับแหล่งท่องเที่ยวใกล้กรุง`}
          to={`/th/blog/10อันดับแหล่งท่องเที่ยวใกล้กรุง`}
        />
        <Redirect
          from={`/en/blog/ขั้นตอนวางแผนทริป`}
          to={`/th/blog/ขั้นตอนวางแผนทริป`}
        />
        <Redirect
          from={`/en/blog/เทคนิคที่ควรรู้ก่อนเลือกรถบัส`}
          to={`/th/blog/เทคนิคที่ควรรู้ก่อนเลือกรถบัส`}
        />
        <Redirect
          from={`/en/blog/5หมู่เกาะสุดฮิตที่ควรลากเพื่อนไปเยือน`}
          to={`/th/blog/5หมู่เกาะสุดฮิตที่ควรลากเพื่อนไปเยือน`}
        />
        <Redirect
          from={`/en/blog/เลือกรถบัสเช่า-ยังไงให้เหมาะสมกับทริปสุดมันที่กำลังรออยู่`}
          to={`/th/blog/เลือกรถบัสเช่า-ยังไงให้เหมาะสมกับทริปสุดมันที่กำลังรออยู่`}
        />
        <Redirect
          from={`/en/blog/สิ่งที่ควรรู้ก่อน-เช่ารถบัส-ให้ปลอดภัยตลอดการเดินทาง`}
          to={`/th/blog/สิ่งที่ควรรู้ก่อน-เช่ารถบัส-ให้ปลอดภัยตลอดการเดินทาง`}
        />
        <Redirect
          from={`/en/blog/เช็คลิสต์รถบัสให้เช่าจาก-HISOBUS-มีกี่ประเภท`}
          to={`/th/blog/เช็คลิสต์รถบัสให้เช่าจาก-HISOBUS-มีกี่ประเภท`}
        />
        <Redirect
          from={`/en/blog/thai-bus-food`}
          to={`/th/blog/thai-bus-food`}
        />
        <Redirect
          from={`/en/blog/9-ที่เที่ยวหน้าหนาว-ขับรถชิลๆ-ใกล้กรุงเทพฯ-นิดเดียว`}
          to={`/th/blog/9-ที่เที่ยวหน้าหนาว-ขับรถชิลๆ-ใกล้กรุงเทพฯ-นิดเดียว`}
        />
        <Redirect
          from={`/en/blog/เช่ารถบัส-และ-รถตู้-!-ทำไมต้อง-Vecabo`}
          to={`/th/blog/เช่ารถบัส-และ-รถตู้-!-ทำไมต้อง-Vecabo`}
        />
        <Redirect
          from={`/en/blog/นั่งรถนานทำอะไรดี`}
          to={`/th/blog/นั่งรถนานทำอะไรดี`}
        />
        <Redirect
          from={`/en/blog/5-สถานที่จัด-Outing-ใกล้กรุงเทพ`}
          to={`/th/blog/5-สถานที่จัด-Outing-ใกล้กรุงเทพ`}
        />
        {/* end redirect section */}

        <Route
          exact
          path={`/`}
          component={asyncComponent(() => import("../home/homePage_v2"))}
        />
        {/* <Route exact path="/home" render={() => <Redirect to="/th" />} />
        <Route exact path="/home" render={() => <Redirect to="/th" />} /> */}
        <Route
          exact
          path={`/th`}
          component={asyncComponent(() => import("../home/homePage_v2"))}
        />
        <Route
          exact
          path={`/th/campaign`}
          component={asyncComponent(() => import("../home/campaignPage"))}
        />
        <Route
          exact
          path={`/en`}
          component={asyncComponent(() => import("../home/homePage_v2"))}
        />
        {/* <Route
          exact
          path={`/:lang/home`}
          component={asyncComponent(() => import("../home/homePage_v2"))}
        /> */}
        <Route
          exact
          path={`/th/gbpredirecdt`}
          component={asyncComponent(() => import("../payment/redirect"))}
        />
        <Route
          exact
          path={`/th/aboutus`}
          component={asyncComponent(() => import("../aboutUs"))}
        />
        <Route
          exact
          path={`/en/aboutus`}
          component={asyncComponent(() => import("../aboutUs/index_en"))}
        />
        <Route
          path={`/:lang/pricing`}
          component={asyncComponent(() => import("../pricing/pricing"))}
        />
        <Route
          exact
          path={`/:lang/blog/พระธาตุประจำวันเกิด`}
          component={asyncComponent(() => import("../blog2/blog1"))}
        />
        <Route
          exact
          path={`/:lang/blog/5ที่เที่ยวใกล้กรุงเทพ`}
          component={asyncComponent(() => import("../blog2/blog2"))}
        />
        <Route
          exact
          path={`/:lang/blog/ขับรถเที่ยวใกล้กรุงเทพฯ-7-ทริป-ชิลๆ-ไปเช้ากลับเย็น`}
          component={asyncComponent(() => import("../blog2/blog3"))}
        />
        <Route
          exact
          path={`/:lang/blog/จุดเด่นเมื่อเช่ารถบัสกับ-HISOBUS`}
          component={asyncComponent(() => import("../blog2/blog4"))}
        />
        <Route
          exact
          path={`/:lang/blog/10-เที่ยวใกล้กรุงเทพฯ-ตามรอยพ่อหลวง-สัมผัสความรู้เคล้าความสุข`}
          component={asyncComponent(() => import("../blog2/blog5"))}
        />
        <Route
          exact
          path={`/:lang/blog/18-ที่เที่ยวกาญจนบุรี-ไปกี่ทีก็ไม่เบื่อ`}
          component={asyncComponent(() => import("../blog2/blog6"))}
        />
        <Route
          exact
          path={`/:lang/blog/1-กว่าจะเป็นรถบัส`}
          component={asyncComponent(() => import("../blog2/blog7"))}
        />
        <Route
          exact
          path={`/:lang/blog/10อันดับแหล่งท่องเที่ยวใกล้กรุง`}
          component={asyncComponent(() => import("../blog2/blog8"))}
        />
        <Route
          exact
          path={`/:lang/blog/ขั้นตอนวางแผนทริป`}
          component={asyncComponent(() => import("../blog2/blog9"))}
        />
        <Route
          exact
          path={`/:lang/blog/เทคนิคที่ควรรู้ก่อนเลือกรถบัส`}
          component={asyncComponent(() => import("../blog2/blog10"))}
        />
        <Route
          exact
          path={`/:lang/blog/5หมู่เกาะสุดฮิตที่ควรลากเพื่อนไปเยือน`}
          component={asyncComponent(() => import("../blog2/blog11"))}
        />
        <Route
          exact
          path={`/:lang/blog/เลือกรถบัสเช่า-ยังไงให้เหมาะสมกับทริปสุดมันที่กำลังรออยู่`}
          component={asyncComponent(() => import("../blog2/blog12"))}
        />
        <Route
          exact
          path={`/:lang/blog/สิ่งที่ควรรู้ก่อน-เช่ารถบัส-ให้ปลอดภัยตลอดการเดินทาง`}
          component={asyncComponent(() => import("../blog2/blog13"))}
        />
        <Route
          exact
          path={`/:lang/blog/เช็คลิสต์รถบัสให้เช่าจาก-HISOBUS-มีกี่ประเภท`}
          component={asyncComponent(() => import("../blog2/blog14"))}
        />
        <Route
          exact
          path={`/:lang/blog/thai-bus-food`}
          component={asyncComponent(() => import("../blog2/blog15"))}
        />
        <Route
          exact
          path={`/:lang/blog/9-ที่เที่ยวหน้าหนาว-ขับรถชิลๆ-ใกล้กรุงเทพฯ-นิดเดียว`}
          component={asyncComponent(() => import("../blog2/blog16"))}
        />
        <Route
          exact
          path={`/:lang/blog/เช่ารถบัส-และ-รถตู้-!-ทำไมต้อง-Vecabo`}
          component={asyncComponent(() => import("../blog2/blog17"))}
        />
        <Route
          exact
          path={`/:lang/blog/กิจกรรมสันทนาการบนรถบัส`}
          component={asyncComponent(() => import("../blog2/blog18"))}
        />
        <Route
          exact
          path={`/:lang/blog/5-สถานที่จัด-Outing-ใกล้กรุงเทพ`}
          component={asyncComponent(() => import("../blog2/blog19"))}
        />
        <Route
          exact
          path={`/:lang/populardeals/`}
          component={asyncComponent(() =>
            import("../popularDeals/popularDeals")
          )}
        />
        <Route
          exact
          path={`/:lang/populardeals/:promotionId`}
          component={asyncComponent(() =>
            import("../popularDeals/StaycationTime_th")
          )}
        />
        <Route
          exact
          path={`/:lang/blog/:id`}
          component={asyncComponent(() => import("../blog/blogDetail"))}
        />
        <Route
          path={`/:lang/blog`}
          component={asyncComponent(() => import("../blog2/blog"))}
        />
        <Route
          exact
          path={`/:lang/confirmemail`}
          component={asyncComponent(() => import("../account/confirmEmail"))}
        />
        <Route
          exact
          path={`/:lang/resetpassword`}
          component={asyncComponent(() =>
            import("../account/confirmResetPassword")
          )}
        />
        <Route
          exact
          path={`/:lang/userinfo`}
          component={asyncComponent(() => import("../account/userProfile"))}
        />
        <Route
          exact
          path={`/:lang/mybooking`}
          component={asyncComponent(() => import("../booking/myBooking"))}
        />
        <Route
          exact
          path={`/:lang/mybookingdetail`}
          component={asyncComponent(() => import("../booking/myBookingDetail"))}
        />
        <Route
          exact
          path={`/:lang/contactus`}
          component={asyncComponent(() => import("../contactUs/contact"))}
        />
        {/* <Route
          exact
          path={`/:lang/booking`}
          component={asyncComponent(() => import("../booking/booking"))}
        /> */}
        <Route
          exact
          path={`/:lang/bookingDetail`}
          component={asyncComponent(() =>
            import("../booking/bookingDetail_v2")
          )}
        />
        <Route
          exact
          path={`/:lang/bookingInfo`}
          component={asyncComponent(() =>
            import("../booking/bookingInfomation")
          )}
        />
        <Route
          exact
          path={`/:lang/bookingDetail/:id`}
          component={asyncComponent(() => import("../booking/bookingDetail"))}
        />
        <Route
          exact
          path={`/:lang/bookingPayment/:id`}
          component={asyncComponent(() =>
            import("../booking/bookingPayment_v2")
          )}
        />
        <Route
          exact
          path={`/:lang/howtopay/`}
          component={asyncComponent(() => import("../payment/banking"))}
        />
        <Route
          exact
          path={`/th/faq`}
          component={asyncComponent(() => import("../faq/index"))}
        />
        <Route
          exact
          path={`/en/faq`}
          component={asyncComponent(() => import("../faq/index_en"))}
        />
        <Route
          exact
          path={`/th/thankyou`}
          component={asyncComponent(() => import("../thankyou"))}
        />
        <Route
          exact
          path={`/en/thankyou`}
          component={asyncComponent(() => import("../thankyou/index_en"))}
        />
        <Route
          exact
          path={`/th/complain`}
          component={asyncComponent(() => import("../complain"))}
        />
        <Route
          exact
          path={`/en/complain`}
          component={asyncComponent(() => import("../complain/index_en"))}
        />
        <Route
          exact
          path={`/th/busstandard`}
          component={asyncComponent(() => import("../busStandard"))}
        />
        <Route
          exact
          path={`/en/busstandard`}
          component={asyncComponent(() => import("../busStandard/index_en"))}
        />
        <Route
          path={`/:lang/PartnerWithUs`}
          component={asyncComponent(() => import("../partnership/partnership"))}
        />
        <Route
          path={`/:lang/BusinessRegister`}
          component={asyncComponent(() =>
            import("../BusinessRegister/BusinessRegister")
          )}
        />
        <Route
          path={`/th/van`}
          component={asyncComponent(() =>
            import("../booking/bookingVanDetail")
          )}
        />
        <Route
          path={`/en/van`}
          component={asyncComponent(() =>
            import("../booking/bookingVanDetail")
          )}
        />
        {/* <Route
          exact
          path={`/:lang/customer`}
          component={asyncComponent(() => import("../customer/customer"))}
        /> */}
        <Route
          exact
          path={`/:lang/customer-trip/:id`}
          component={asyncComponent(() => import("../customer/customer-trip"))}
        />
        <Route
          exact
          path={`/:lang/assurer`}
          component={asyncComponent(() => import("../assurer/assurer"))}
        />
        <Route
          exact
          path={`/:lang/รถรับส่งพนักงาน`}
          component={asyncComponent(() => import("../employee/employee"))}
        />
        <Route
          exact
          path={`/:lang/cookie`}
          component={asyncComponent(() => import("../cookie/index"))}
        />
        <Route
          exact
          path={`/:lang/tool`}
          component={asyncComponent(() => import("../management"))}
        />
        <Route
          exact
          path={`/:lang/404`}
          component={asyncComponent(() => import("../pages/404"))}
        />
        <Route
          path={`/:lang`}
          component={asyncComponent(() => import("../pages/404"))}
        />
      </Switch>
    )
  }
}
export default AppRouter



// WEBPACK FOOTER //
// ./src/containers/App/AppRouter.tsx